/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';

// material
import { } from '@insticator/insticator-ui'; // iui-material
import GeneralSection from 'pages/dashboard/commenting/configuration/generalsection/generalsection';
import ModerationSection from 'pages/dashboard/commenting/configuration/moderationsection/moderationsection';
import CommentsTreeSection from 'pages/dashboard/commenting/configuration/commentstreesection/commentstreesection';
import ColorSchemeSection from 'pages/dashboard/commenting/configuration/colorschemesection/colorschemesection';
import AvatarSection from 'pages/dashboard/commenting/configuration/avatarsection/avatarsection';
import CommunitySection from 'pages/dashboard/commenting/configuration/communitysection/communitysection';

// utils
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/commenting/configuration/configuration_styles';


/* ========== ~~~~~~~~~~ COMMENTING CONFIGURATION ~~~~~~~~~~ ========== */
const Configuration = (props) => {
  return (    
    <div className={`configuration ${props.classes.configuration}`}>
      <GeneralSection />
      <ModerationSection />
      <CommentsTreeSection />
      <ColorSchemeSection />
      <AvatarSection />
      <CommunitySection />
    </div>
  );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Configuration);
